module.exports = __webpack_public_path__ + "static/media/navy-comment.17e3816b.svg";